import { MODAL_TYPES_SEMAFORO } from "../config/MODAL_TYPES";
import CtaCtePendienteModal from "./CtaCtePendienteModal";
import FiltersModal from "./FiltersModal";

const ModalManagerSemaforo = ({ modal, onClose, refresh, showToast }) => {
  if (!modal) return null;

  console.log("Data del modal: ", modal);

  switch (modal.type) {
    case MODAL_TYPES_SEMAFORO.ABRIR_CUENTACORRIENTE:
      return (
        <CtaCtePendienteModal open onClose={onClose} cliente={modal.cliente} />
      );

    case MODAL_TYPES_SEMAFORO.ABRIR_FILTROS:
      return (
        <FiltersModal
          open
          onClose={onClose}
          filtros={modal.filtros}
          setFiltros={modal.setFiltros}
          sucursales={modal.sucursales}
          categorias={modal.categorias}
          clientes={modal.clientes}
          clientesEnvasado={modal.clientesEnvasado}
        />
      );

    default:
      return null;
  }
};

export default ModalManagerSemaforo;
